@if (ranking) {
  <section class="ranking" [ngClass]="{red: ranking.isTemporary}" [title]="ranking.title">
    @for (icon of ranking.icons; track icon) {
      <mat-icon>diamond</mat-icon>
    }
  </section>
}
